module.exports = __webpack_public_path__ + "static/media/commercial_project_selected.1fac3f35.svg";